import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('tripGroup');
const GET_GROUPS = define('GET_GROUPS', true);
const GET_GROUP = define('GET_GROUP', true);
const CREATE_GROUP = define('CREATE_GROUP', true);
const UPDATE_GROUP = define('UPDATE_GROUP', true);
const REMOVE_GROUP = define('REMOVE_GROUP', true);

const initialState = {
  loadingGroups: true,
  groups: [],
  loadingGroup: true,
  group: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS.PENDING:
      return {
        ...state,
        loadingGroups: true
      };
    case GET_GROUPS.RESOLVED:
      return {
        ...state,
        loadingGroups: false,
        groups: action.data
      };
    case GET_GROUP.PENDING:
      return {
        ...state,
        loadingGroup: true
      };
    case GET_GROUP.RESOLVED:
      return {
        ...state,
        loadingGroup: false,
        group: action.data,
      };
    default: return state;
  }
};

export const actions = {
  getTripGroups: () => ({
    type: GET_GROUPS,
    promise: api.get('/trip-group'),
    error: 'Unable to get all trip group',
  }),
  getTripGroup: groupId => ({
    type: GET_GROUP,
    promise: api.get(`/trip-group/${groupId}`),
    error: 'Unable to get trip group item'
  }),
  createGroup: data => ({
    type: CREATE_GROUP,
    promise: api.post('/trip-group', data),
    success: 'Trip group has been created',
    error: 'Unable to create new group'
  }),
  updateGroup: (id, data) => ({
    type: UPDATE_GROUP,
    promise: api.put(`/trip-group/${id}`, data),
    success: 'Trip group has been updated',
    error: 'Unable to update group'
  }),
  deleteGroup: id => ({
    type: REMOVE_GROUP,
    promise: api.delete(`/trip-group/${id}`),
    success: 'Trip group has been deleted',
    error: 'Unable to delete group'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/trip-group.js